// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Distribution_wrapper__44p0r","grid":"Distribution_grid___iVIK","share-wrapper":"Distribution_share-wrapper__uJc_4","warning-box":"Distribution_warning-box__qlxUF"};